import { useGlobalContext } from '@/context/Global/GlobalContext';
import { DashboardUserType } from '@/utils/enums';
import { useIsMobile } from '@/utils/isMobile';
import { Stack } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoginForm, LoginSellerProps } from '.';
import { LoginArt } from './LoginArt';

export const LoginContainer = (props: LoginSellerProps) => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const { session } = useGlobalContext();

  useEffect(() => {
    if (!session) return;
    if (session.type === DashboardUserType.ADMIN) return navigate('/admin');
    if (session.type === DashboardUserType.SELLER) return navigate('/seller');
  }, [session]);

  return (
    <Stack
      direction={'row'}
      sx={{
        width: '100vw',
        height: '100vh',
        justifyContent: 'center',
      }}
    >
      {!isMobile && <LoginArt loginType={props.loginType} />}
      <LoginForm loginType={props.loginType} />
    </Stack>
  );
};
